/* eslint-disable camelcase */
import React from "react"
import { FormikProvider, useFormik } from "formik"
import * as yup from "yup"

import Button from "@components/ui/Button/Button"
import Loader from "@components/ui/Loader/BarLoader"
import List from "@components/ui/List/List"
import FormTextInput from "@components/prototypes/form-elements/FormTextInput"
import { baseURLValidator } from "@framework/constants/common"

export const validationSchema = yup.object().shape({
  name: yup
    .string()
    .label("Connector Name")
    .required("Field is required")
    .min(3)
    .max(64)
    .trim()
    .default(""),

  clientId: yup
    .string()
    .label("Username")
    .required("Field is required")
    .trim()
    .default(""),

  clientSecret: yup
    .string()
    .label("Password")
    .required("Field is required")
    .trim()
    .default(""),

  baseURL: baseURLValidator.clone().label("Base URL").trim().default(""),
})

export type FormDataType = yup.InferType<typeof validationSchema>

export interface ConnectorEC2SMBFormProps {
  initialValues?: Partial<FormDataType>
  isLoading?: boolean
  onSubmit: (form: FormDataType) => void
}

const ConnectorEC2SMBForm: React.FC<ConnectorEC2SMBFormProps> = ({
  isLoading,
  initialValues = {},
  onSubmit,
}) => {
  const formik = useFormik<FormDataType>({
    initialValues: validationSchema.cast(initialValues, { stripUnknown: true }),
    validationSchema,
    onSubmit,
  })

  return (
    <FormikProvider value={formik}>
      <form onSubmit={formik.handleSubmit}>
        <List gutter="24">
          <FormTextInput
            name="name"
            placeholder="Connector name"
            disabled={isLoading}
            key="name"
          />

          <FormTextInput
            name="clientId"
            placeholder="Username"
            disabled={isLoading}
            key="client_id"
          />

          <FormTextInput
            name="clientSecret"
            placeholder="Password"
            disabled={isLoading}
            key="client_secret"
          />

          <FormTextInput
            name="baseURL"
            placeholder="Base URL"
            disabled={isLoading}
            key="base_url"
          />

          <Button
            disabled={isLoading}
            color="primary"
            type="submit"
            after={isLoading && <Loader />}
          >
            Connect
          </Button>
        </List>
      </form>
    </FormikProvider>
  )
}

export default ConnectorEC2SMBForm
